import { Config } from '@chegg-wt/core/config'
import { AppRouteCreators } from '@chegg-wt/core/types/core'
import { EnumLiteralsOf } from '@chegg-wt/core/types/helpers'
import { SyntheticRouteName } from '../actions'

const rioPageName = {
  homepage: 'homepage',
  profile: 'profile',
  logout: 'logout',
  signup: 'signup',
  upgrade: 'upgrade',
  login: 'login',
  gateway: 'gateway',
  folders: 'folders',
  dashboard: 'holistic dash',
  citationsHome: 'citations home',
  citationsDashboard: 'citations dash',
  bibliography: 'citation bibliography',
  source: 'citation source',
  search: 'citation search',
  searchResults: 'citation search results',
  eval: 'citation eval',
  form: 'citation form',
  uploadLp: 'upload lp',
  error: 'error',
  authModal: 'auth modal',
  paywallModal: 'paywall modal',
  accountExitPopup: 'create account - exit popup',
  checkPaperExitPopup: 'check paper - exit popup',
  modalCreateAccount: 'iFrame auth modal - create account',
  accountStyleGateModal: 'create account - style gate',
  accountGateModal: 'create account - citation unlock modal',
}

type PageName = EnumLiteralsOf<typeof rioPageName>
type RouteNameToRioPageNameMap = Partial<
  Record<keyof AppRouteCreators | SyntheticRouteName, PageName>
>

export const routeToRioPageNameMap: RouteNameToRioPageNameMap = {
  toProfile: rioPageName.profile,
  toLogout: rioPageName.logout,
  toSignup: rioPageName.signup,
  toUpgrade: rioPageName.upgrade,
  toLogin: rioPageName.login,
  toGateway: rioPageName.gateway,
  toSourceTypeSelection: rioPageName.source,
  toSourceSearch: rioPageName.search,
  toSourceSelection: rioPageName.searchResults,
  toSourceConfirmation: rioPageName.eval,
  toNewCitation: rioPageName.form,
  toManualCitation: rioPageName.form,
  toEditCitation: rioPageName.form,
  toBibliography: rioPageName.bibliography,
  toProject: rioPageName.bibliography,
  toFolders: rioPageName.folders,
  toDashboard: rioPageName.dashboard,
  toCitationsHome: Config.citationsHomeIsSubPage
    ? rioPageName.citationsHome
    : rioPageName.homepage,
  toCitationsDashboard: rioPageName.citationsDashboard,
  toCitationList: rioPageName.bibliography,
  toCitationListSource: rioPageName.search,
  toCitationListForm: rioPageName.form,
  // `toUploadLp` is CW's homepage
  toUploadLp: rioPageName.uploadLp,
  toError: rioPageName.error,
  // Synthetic Routes
  toSearchResult: rioPageName.searchResults,
  toAuthModal: rioPageName.authModal,
  toSubscriptionModal: rioPageName.paywallModal,
  toCreateAccountExitPopup: rioPageName.accountExitPopup,
  toCheckPaperExitPopup: rioPageName.checkPaperExitPopup,
  toModalCreateAccount: rioPageName.modalCreateAccount,
  toAccountStyleGateModal: rioPageName.accountStyleGateModal,
  toAccountGateModal: rioPageName.accountGateModal,
} as const

export const pageGroups = {
  dashboard: 'dashboard',
  citationFlow: 'core citation flow',
  landingPage: 'awt',
}

type PageGroup = EnumLiteralsOf<typeof pageGroups>
type RouteNameToPageGroupMap = Partial<
  Record<keyof AppRouteCreators | SyntheticRouteName, PageGroup>
>

export const routeNameToPageGroup: RouteNameToPageGroupMap = {
  toDashboard: pageGroups.dashboard,
  toCitationsDashboard: pageGroups.dashboard,
  toCitationList: pageGroups.citationFlow,
  toCitationListSource: pageGroups.citationFlow,
  toCitationListForm: pageGroups.citationFlow,
  toSearchResult: pageGroups.citationFlow,
  toUploadLp: pageGroups.landingPage,
}

export const pageSubGroups = {
  dashboard: 'holistic dash',
  citationsDashboard: 'citations dash',
  bibliography: 'bibliography',
  search: 'search',
  searchResults: 'citation search results',
  form: 'citation form',
  landingPage: 'upload lp',
}

type PageSubGroup = EnumLiteralsOf<typeof pageSubGroups>
type RouteNameToPageSubGroupMap = Partial<
  Record<keyof AppRouteCreators | SyntheticRouteName, PageSubGroup>
>

export const routeNameToPageSubGroupMap: RouteNameToPageSubGroupMap = {
  toDashboard: pageSubGroups.dashboard,
  toCitationsDashboard: pageSubGroups.citationsDashboard,
  toCitationList: pageSubGroups.bibliography,
  toCitationListSource: pageSubGroups.search,
  toCitationListForm: pageSubGroups.form,
  toSearchResult: pageSubGroups.searchResults,
  toUploadLp: pageSubGroups.landingPage,
}
